'use client'

import { memo } from 'react'

import { VaultV2PerformanceFees, VaultV2PerformanceReturns } from '../components'
import VaultV2PerformanceLayout from '../components/VaultV2PerformanceLayout'

const VaultV2PerformanceLoading = () => {
  return (
    <VaultV2PerformanceLayout>
      <VaultV2PerformanceReturns isLoading />
      <VaultV2PerformanceFees isLoading />
    </VaultV2PerformanceLayout>
  )
}

export default memo(VaultV2PerformanceLoading)
